import clsx from "clsx";
import { CSSProperties, FC } from "react";
import styles from "./styles.scss";

interface CompanyLogoProps {
  className?: string;
  style?: CSSProperties;
}

export const CompanyLogo: FC<CompanyLogoProps> = ({ className, style }) => {
  return (
    <div className={clsx(styles.logoWrapper, className)} style={style}>
      <div className={clsx(styles.darkTheme, styles.logo)} />
      <div className={clsx(styles.lightTheme, styles.logo)} />
    </div>
  );
};
